import { getFrameShadow } from 'components/Tile/shadows'
import { css, styled } from 'styled-components'

const fillParent = css`
  width: 100%;
  height: 100%;
`

export const Book = styled.div`
  position: relative;
  ${fillParent}
  background-color: ${({ theme }) => theme.colors.grayBright};
  box-shadow: ${getFrameShadow()};
  container-type: inline-size;
`

export const CoverClip = styled.div`
  position: relative;
  ${fillParent}
  overflow: hidden;
`

export const CoverImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  ${fillParent}
  object-fit: cover;
  display: block;
`

export const DesignedCover = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
`

export const CoverPlaceholder = styled.div`
  ${fillParent}
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    ${fillParent}
  }
`

export const Spine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  pointer-events: none;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
  }

  &::before {
    left: 0;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.15);
  }

  &::after {
    left: 3px;
    width: 1px;
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: -1px 0 0 rgba(0, 0, 0, 0.2);
  }
`

export const BottomGradient = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.55) 100%
  );
  pointer-events: none;
`

export const Title = styled.div`
  position: absolute;
  left: 3px;
  right: 0;
  bottom: 6px;
  color: #ffffff;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
`
